var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaasGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3_01_Integrations",
    transform: "translate(-637.000000, -228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(637.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EAECF5",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud-24px",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 43 0 43 43 0 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8625,18.324186 C32.6725,12.427093 27.37,8 21,8 C15.9425,8 11.55,10.8032558 9.3625,14.9055814 C4.095,15.4525581 0,19.8112791 0,25.0930233 C0,30.750814 4.7075,35.3488372 10.5,35.3488372 L33.25,35.3488372 C38.08,35.3488372 42,31.52 42,26.8023256 C42,22.2897674 38.4125,18.6318605 33.8625,18.324186 Z",
    id: "Path",
    fill: "#768097",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaasGeneric);
export default __webpack_public_path__ + "static/media/saas_generic.4051f331.svg";
export { ForwardRef as ReactComponent };